import { render, staticRenderFns } from "./SmsSchool.vue?vue&type=template&id=dc92fed6&scoped=true"
import script from "./SmsSchool.vue?vue&type=script&lang=js"
export * from "./SmsSchool.vue?vue&type=script&lang=js"
import style0 from "./SmsSchool.vue?vue&type=style&index=0&id=dc92fed6&lang=css"
import style1 from "./SmsSchool.vue?vue&type=style&index=1&id=dc92fed6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc92fed6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc92fed6')) {
      api.createRecord('dc92fed6', component.options)
    } else {
      api.reload('dc92fed6', component.options)
    }
    module.hot.accept("./SmsSchool.vue?vue&type=template&id=dc92fed6&scoped=true", function () {
      api.rerender('dc92fed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/SmsSchool.vue"
export default component.exports